export default "__VITE_ASSET__CD3rMsp6__"